module.exports = __webpack_public_path__ + "img/image 15.363c2df3.png";